import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Icon, ButtonIcon, TextInput, ButtonGroup, Switcher, Button, Checkbox, FileUploadV2, Modal, Notification, Dropdown, TextArea, DataTable, Breadcrumb } from "pepsico-ds";
import { useEffect, useState } from "react";
import helpOutlineIcon from "../../assets/guest_invitation/help_outline.svg"
import "./idx-attribute-bulk-load.css"
import idxService from "./idx.service";
import { toast, ToastContainer } from 'react-toastify';
import { useLoading } from "../../loader";
import axios from "axios";
import { ActionTypes } from "../../Redux/Constants/ActionTypes";
import { useDispatch, useSelector } from "react-redux";

const IdxReportingSelfService = () => {
    const { t, i18n } = useTranslation();
    const { REACT_APP_API_ENDPOINT } = process.env;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const showIDXSuccessNotification = useSelector((state)=>state?.idxState?.showSuccessNotification);
    useEffect(()=>{
        if(showIDXSuccessNotification){
            setTimeout(() => {
            dispatch({type:ActionTypes.IDX_NOTIFICATION, payload: false});
            navigate('/home');
            }, 5000);
        }
    },[showIDXSuccessNotification]);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const { showLoader, hideLoader } = useLoading();
    const [showErrorModal, setErrorShowModal] = useState(false);
    const [copyButtonText, setCopyButtonText] = useState(t('nonArExtension.copy'));
    const [requestData, setRequestData] = useState(null);
    const [returningAttribute, setReturningAttribute] = useState([]);
    const [isValid, setIsValid] = useState(false);
    const [isSubmitFailed, setIsSubmitFailed] = useState(false);
    const [returningAttributes, setReturningAttributes] = useState([
        {
            id: 'pepUserStatus', displayText: t("idx.hr_status_pepUserStatus")
        },
        {
            id: 'pepTermDate', displayText: t("idx.trem_date_pepTermDate")
        },
        {
            id: 'mail', displayText: t("idx.email_mail")
        }
    ]);
    const [showValidationError, setShowValidationError] = useState(false);
    const [validationErrorCounts, setValidationErrorCounts] = useState({totalRow:0, valid: 0, blankRow: 0, issues:0});
    const [validationErrorModalData, setValidationErrorModalData] = useState([])
    const validationErrorColumns = [
      { columnKey: "row", header: t("idx.row"), showColumnVisibility: true, initialSize: 140 },
      { columnKey: "message", header: t("idx.message"), showColumnVisibility: true, initialSize: 360 },
    ];

    const resetFields = () => {
        setReturningAttribute([]);
        setUploadedFiles([]);
        setIsValid(false);
        setShowValidationError(false);
        setValidationErrorModalData([]);
        setValidationErrorCounts({totalRow:0, valid: 0, blankRow: 0, issues:0});
    }

    useEffect(()=>{
        if(uploadedFiles.length>0){
            handleValidation();
        }
        if(isSubmitFailed) setIsSubmitFailed(false);

    },[uploadedFiles])

    const handleValidation = async () => {
        showLoader();
        try{
            const formData = new FormData();
            formData.append("file", uploadedFiles[0]);
            returningAttribute.forEach(item => {
                formData.append("attributes", item?.id);
            });
            const responseValidate = await idxService.bulkLoadValidate(formData, "type=export");

            if(responseValidate?.valid){
                setIsValid(true)
            }
            else {
                if(responseValidate?.totalRows || responseValidate?.acceptedRows || responseValidate?.skippedRows || responseValidate?.validationErrors?.length){
                    const errorCounts = {
                        totalRow: responseValidate?.totalRows || 0, 
                        valid: responseValidate?.acceptedRows || 0, 
                        blankRow: responseValidate?.skippedRows || 0, 
                        issues: responseValidate?.validationErrors?.length || 0
                    };
                    setValidationErrorCounts(errorCounts);
                    setShowValidationError(true);
                    if(responseValidate?.validationErrors?.length)setValidationErrorModalData(responseValidate?.validationErrors?.map((err)=>({row:err?.split(":")?.[0], message:err?.split(":")?.[1]})));
                }
                if(!responseValidate?.validationErrors?.length && responseValidate?.status === "Failed" && responseValidate?.errorMessage?.includes?.("Invalid CSV headers")){
                    setValidationErrorModalData([{row:"Expected headers", message:responseValidate?.errorMessage?.split(":")?.[1]}]);
                    setValidationErrorCounts({...validationErrorCounts,issues:1});
                    setShowValidationError(true);
                }else{
                    toast.error( responseValidate?.errorMessage ||responseValidate?.error_msg ,"error");
                }
                hideLoader();
                setIsValid(false);
            }
        }catch (error) {
            hideLoader();
            toast.error(t("entraGuest.request_fail_message"),"error");
        }finally{
            hideLoader();
        }
    }

    const handleSubmit = async () => {
        showLoader();
        try{
            const formData = new FormData();
            formData.append("file", uploadedFiles[0]);
            returningAttribute.forEach(item => {
                formData.append("attributes", item?.id);
            });
            const response = await idxService.submitReportingSelf(formData);
            if (response?.responseStatus === 'Failed' || response?.status === 'Failed') {
                const rows = response?.errorMessage.match(/Row \d+:.*?(?=\s\||$)/g);
                if(rows.length>0){
                    setValidationErrorCounts({...validationErrorCounts, issues: rows.length});
                    setValidationErrorModalData(rows?.map((err)=>({row:err?.split?.(":")?.[0], message:err?.split?.(":")?.[1]})));
                    setShowValidationError(true);
                }else{
                    toast.error( response?.errorMessage ||response?.error_msg ,"error");
                }
                hideLoader();
                setIsSubmitFailed(true);
            }
            else if(response?.error_msg || response?.error_code){
                toast.error(response?.error_msg || t("entraGuest.request_fail_message"),"error");
                setIsSubmitFailed(true);
            }
            else {
                hideLoader();
                setRequestData(response);
                resetFields()
                dispatch({type:ActionTypes.IDX_NOTIFICATION, payload: true});
                window.scrollTo(0,0);
            }
        }catch (error) {
            hideLoader();
            toast.error(t("entraGuest.request_fail_message"),"error");
        }finally{
            hideLoader();
        }
    }

    const disableSubmit = () => {
        return !(uploadedFiles.length && returningAttribute.length && isValid && !isSubmitFailed)
    }

    const closeModal = () => {
        setErrorShowModal(false);
    }

    const onClickCopynumber = () => {
        if (requestData?.requestNumber) {
            navigator.clipboard.writeText(requestData?.requestNumber?.toString?.()).then(() => {
                setCopyButtonText(t('nonArExtension.copied'));
            }).catch(err => {
                console.error("Failed to copy text: ", err);
            });
        }
    };

    const onViewRequest = () => {
        const statePayload = { type: "requestNumber", value: requestData?.requestNumber };
        navigate("/audit-requests", { state: statePayload });
    }

    const renderConfirmModal = () => {
        return (
            <div className="validation-error-modal">
                <Modal
                    size="large"
                    id=""
                    className={isMobile ? "mobile-view-request-modal hide-rows-per-page validation-error-modal" : "validation-error-modal hide-rows-per-page"}
                    closeOnOutsideClick = {false}
                    onCloseModal={closeModal}
                    showCloseButton
                    showModal={showErrorModal}
                    style={{}}
                    tertiaryButtonProps=""
                    showAuxiliaryButton={false}
                    showPrimaryButton={false}
                    showSecondaryButton={false}
                    title={`${t("idx.showing")} ${validationErrorCounts?.issues} ${t("idx.issues")}`}
                    type="fluid"
                >
                    <DataTable
                        className="datatable"
                        columns={validationErrorColumns}
                        key={i18n.language}
                        enableSorting={true}
                        data={validationErrorModalData}
                        pageIndex={0}
                        pageSize={10}
                        selection="single"
                        tableHeader=""
                        size="large"
                        showTableHeader={true}
                        showTitle={true}
                        showSearchOption={false}
                        showColumnFilters={false}
                        showDescription={false}
                        tableDescription=""
                        showPagination={true}
                        noDataDescriptionText=""
                    />
                </Modal>
            </div>
        )
    }

    return (
        <>
            <div className="idx-main-container">
                <div
                    className={isMobile ? "row" : "container"}
                    style={{
                        background: "none",
                        boxShadow: "none",
                        justifyContent: isMobile ? "center" : "",
                    }}
                >
                    <div
                        style={{
                            width: "100%",
                            flexDirection: isMobile ? "column" : "row",
                            gap: isMobile ? "0px" : "15px",
                            flexWrap: "wrap",
                            flex: 1,
                        }}
                    >
                        {showIDXSuccessNotification && <Notification
                            className="mb-3"
                            primaryActionOnClick={function w8e(){}}
                            secondaryActionOnClick={function w8e(){}}
                            showActionButtons={false}
                            showIcon
                            showText={false}
                            showTitle
                            style={{}}
                            title={t("idx.request_submitted_successfully")}
                            type="success"
                        />}
                        <div className={isMobile ? "row mt-2" : ""} style={{ justifyContent: isMobile ? "center" : "" }}>
                            {/* <div className={`${isMobile ? 'pl-4 pr-4 ml-4 mr-4' : 'd-flex mb-0'}  align-items-center ad-main-heading-container`} style={{ gap: "12px" }}>
                                <ButtonIcon
                                    className=""
                                    color="Interaction/Active"
                                    icon="arrow_backward"
                                    label="Label"
                                    onClick={() => navigate(-1)}
                                    size="medium"
                                    style={{}}
                                    type="default"
                                />
                                <div className="d-flex flex-column">
                                    <div className="ad-main-heading">{t("idx.reporting_self_service")}</div>
                                </div>
                            </div> */}

                             <div
                                className={`${isMobile ? 'pl-4 pr-4 ml-4 mr-4' : ''} ad-main-heading-container`}
                            >
                                <Breadcrumb
                                    homeIcon={{
                                        icon: "home",
                                        onClick:()=>{
                                        navigate("/home")
                                        }
                                    }}
                                    breadcrumbs={[
                                        {
                                            label: "Home",
                                        },
                                        {
                                            label: "Reporting Self Service",
                                        },
                                    ]}
                                    className="idx-breadcrumb"
                                    useAnchor
                                />

                                <div className="ad-page-header">
                                    <div className="ad-main-heading">
                                        {t("idx.reporting_self_service")}
                                    </div>
                                </div>
                            </div>
                            <div
                                className="card-layout reg-card mb-3 mb-md-0 active-directory-card-container idx-container"
                                style={{
                                    flex: isMobile ? "unset" : "0 0 calc(66.666% - 7.5px)",
                                    width: isMobile ? "100%" : "auto",
                                    flexDirection: isMobile ? "column" : "row",
                                    gap: "1rem"
                                }}
                            >
                                <div className="w-100">
                                    <div className="card card-content align-items-center">
                                        <div className="bulk-upload-section w-50">
                                            <div className="download-template-section">
                                                <div className="download-template-label">
                                                    <Icon
                                                        alt="alt value"
                                                        icon="download"
                                                        size="18px"
                                                        className=""
                                                    />
                                                    <div className="d-flex flex-column text-left">
                                                        <div className="download-template-heading">{t("idx.download_the_gpid_excel_template")}</div>
                                                    </div>
                                                </div>
                                                <Button
                                                    className=""
                                                    loadingText=""
                                                    size="large"
                                                    style={{}}
                                                    text={t("entraGuest.download")}
                                                    variant="primary"
                                                    onClick={async()=>{
                                                        try {
                                                        const response = await axios.get(REACT_APP_API_ENDPOINT?.replace?.("/myidm","") + "bulk-load/csv/template?type=export", {
                                                            responseType: "blob",
                                                        });
                        
                                                        const blob = new Blob([response.data], { type: "text/csv" });
                                                        const url = window.URL.createObjectURL(blob);
                        
                                                        const link = document.createElement("a");
                                                        link.href = url;
                                                        link.setAttribute("download", "IDX_Reporting_Self_Service.csv");
                                                        document.body.appendChild(link);
                                                        link.click();
                        
                                                        link.parentNode.removeChild(link);
                                                        window.URL.revokeObjectURL(url);
                                                        } catch (error) {
                                                        console.error("Error downloading the file:", error);
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <FileUploadV2
                                                accept=".csv"
                                                buttonLabel="Upload file"
                                                description={t("entraGuest.file_upload_desc")}
                                                label={t("idx.upload_gpid_file")}
                                                type="default"
                                                uploadIcon="cloud_upload"
                                                uploadedFilesLabel={t("entraGuest.uploaded_files")}
                                                variant="complete"
                                                isShowUploadedFileCount={false}
                                                helperText={t("idx.maximum_of_5000_records_per_upload")}
                                                files={uploadedFiles}
                                                disabled={uploadedFiles.length>0}
                                                onUpdate={(files) => {
                                                    setUploadedFiles([files])
                                                    if(showValidationError){
                                                        setShowValidationError(false);
                                                        setValidationErrorModalData([]);
                                                        setValidationErrorCounts({totalRow:0, valid: 0, blankRow: 0, issues:0});
                                                        setIsValid(false);
                                                    }
                                                }}
                                                onDelete={(i) => {
                                                    const filteredUploadedFiles = uploadedFiles.filter((f, index) => i !== index)
                                                    setUploadedFiles(filteredUploadedFiles)
                                                    if(showValidationError){
                                                        setShowValidationError(false);
                                                        setValidationErrorModalData([]);
                                                        setValidationErrorCounts({totalRow:0, valid: 0, blankRow: 0, issues:0});
                                                        setIsValid(false);
                                                    }
                                                }}
                                                multiple={false}
                                                required={true}
                                            />
                                            {
                                                showValidationError ?
                                                <div className="idx-validation-error-section">
                                                    <Icon
                                                        alt="alt value"
                                                        icon="error"
                                                        size="18px"
                                                        className="main-icon"
                                                    />
                                                    <div className="idx-validation-error-main-section">
                                                        <div className="error-heading mb-2">{t("idx.validation_failed")}</div>
                                                        <div className="error-desc mb-2">{t("idx.validation_failed_desc")}</div>
                                                        <div className="error-tags-section">
                                                            <div className="total-row-tag">
                                                                <Icon
                                                                    alt="alt value"
                                                                    icon="table_rows"
                                                                    size="18px"
                                                                    className=""
                                                                />
                                                                <div>{`${validationErrorCounts?.totalRow} ${t("idx.total_rows")}`}</div>
                                                            </div>
                                                            <div className="valid-tag">
                                                                <Icon
                                                                    alt="alt value"
                                                                    icon="check"
                                                                    size="18px"
                                                                    className=""
                                                                />
                                                                <div>{`${validationErrorCounts?.valid} ${t("idx.valid")}`}</div>
                                                            </div>
                                                            <div className="blank-row-tag">
                                                                <Icon
                                                                    alt="alt value"
                                                                    icon="border_clear"
                                                                    size="18px"
                                                                    className=""
                                                                />
                                                                <div>{`${validationErrorCounts?.blankRow} ${t("idx.blank_rows")}`}</div>
                                                            </div>
                                                            <div className="issues-tag">
                                                                <Icon
                                                                    alt="alt value"
                                                                    icon="error"
                                                                    size="18px"
                                                                    className=""
                                                                />
                                                                <div>{`${validationErrorCounts?.issues} ${t("idx.issues")}`}</div>
                                                            </div>
                                                            <div className="show-issues-tag" disabled={!validationErrorModalData.length} onClick={()=>setErrorShowModal(true)}>{t("idx.show_issues")}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                : null
                                            }
                                            <Dropdown
                                                className="mb-3"
                                                childList={returningAttributes}
                                                label={t("idx.returning_attributes")}
                                                placeholder={t("RequestGPIDForNonEmployee.select_btn_label")}
                                                menuPosition="top-right"
                                                isClearable={true}
                                                selection="multiple"
                                                size="medium"
                                                setSelectedValue={(selected) => {
                                                    setReturningAttribute(selected);
                                                    if(isSubmitFailed) setIsSubmitFailed(false);
                                                }}
                                                selectedValue={returningAttribute}
                                                onKeyDown={(e) => e.preventDefault()}
                                                showLabelIcon={false}
                                                isRequired
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="idx-footer mt-3">
                <div className="row footer-row-with-footer-buttons">
                    <div className="footer-buttons">
                        <div className="col-md-auto align-self-center d-flex mb-3 mb-md-0 px-md-0 justify-content-center">
                            <Button
                                className="search-user-cancel-button mr-md-2 my-0"
                                type="button"
                                size="medium"
                                text={t("RequestGPIDForNonEmployee.cancel_btn_label")}
                                variant="tertiary"
                                onClick={() => { navigate(-1) }}
                            />
                        </div>
                        <div className="col-md-auto align-self-center d-flex mb-3 mb-md-0">
                            <Button
                                className="search-user-select-button request-button my-0 px-3 justify-content-center"
                                type="button"
                                size="medium"
                                text={t("nonArExtension.submit")}
                                variant="primary"
                                onClick={handleSubmit}
                                disabled={disableSubmit()}
                            />
                        </div>
                    </div>
                </div>
                <ToastContainer
                    position="bottom-center"
                />
                {showErrorModal && renderConfirmModal()}
            </div>
        </>
    )
}

export default IdxReportingSelfService;